module.exports = __webpack_public_path__ + "static/media/id-example-en.bf64c199.png";